import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useEffect } from 'react';
import { Stack, xcss } from '@atlaskit/primitives';
import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import { getTypedJSONResultData } from '../ai-answer-dialog/utils/getTypedJSONResultData';
import { useAnalytics, useSAINUsageCriteriaMet } from '../common/controller/analytics';
import { onKnowledgeCardShown } from './analytics';
import { getEditDistanceRatio } from './gql/hydrate-team-card';
import { KnowledgeCardsBody } from './knowledge-cards-body';
import { KnowledgeCardsHeader } from './knowledge-cards-header';
import { SeparatorLine } from './separator-line';
import { KnowledgeCardsIntentType } from './types';
var CardContainerStyles = xcss({
  borderRadius: "var(--ds-border-radius-100, 4px)",
  borderWidth: "var(--ds-border-width, 1px)",
  borderStyle: 'solid',
  borderColor: 'color.border'
});
export var TeamKnowledgeCard = /*#__PURE__*/memo(function () {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    currentUserId = _useAIAnswerContext.userDetails.id;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var answerString = commonAttributes.answerString,
    query = commonAttributes.query;
  var data = getTypedJSONResultData(answerString).parsedResult;
  var editDistanceRatio = getEditDistanceRatio(query, data.name);
  useEffect(function () {
    if (data.id) {
      fireSAINUsageEvent({
        commonAttributes: commonAttributes
      });
      fireAnalyticsEvent(onKnowledgeCardShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        cardType: KnowledgeCardsIntentType.TEAM,
        extraAttributes: {
          editDistance: editDistanceRatio
        }
      })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return data.id ? /*#__PURE__*/React.createElement(Stack, {
    xcss: CardContainerStyles
  }, /*#__PURE__*/React.createElement(KnowledgeCardsHeader, {
    type: KnowledgeCardsIntentType.TEAM,
    name: data.name,
    avatarUrl: data.avatarUrl,
    profileUrl: data.url
  }), /*#__PURE__*/React.createElement(SeparatorLine, null), /*#__PURE__*/React.createElement(KnowledgeCardsBody, {
    type: KnowledgeCardsIntentType.TEAM,
    currentUserId: currentUserId || '',
    recentActivity: data.recentActivity,
    recommendedUsers: data.members,
    profileUrl: data.url || '',
    viewAllUrl: data.url || ''
  })) : null;
});